import { ColumnType } from './Store/Column';
import { DataType } from './DataType';
import { BField, FieldType } from './Field';
import { AggregateFunction } from './Formula/Funcs/AggFunc';
export class DataField extends BField {
    constructor(column, dataType, roleType, varType, name) {
        super();
        this._column = column;
        this._varType = varType;
        this._dataType = dataType;
        this._roleType = roleType;
        this._name = name || column.name;
    }
    get name() {
        return this._name;
    }
    get column() {
        return this._column;
    }
    get columnType() {
        return this.column.type;
    }
    get type() {
        return FieldType.DATA;
    }
    get dataType() {
        switch (this.columnType) {
            case ColumnType.BOOLEAN:
                return DataType.BOOLEAN;
            case ColumnType.DATE:
                return DataType.DATE;
            case ColumnType.DATETIME:
                return DataType.DATETIME;
            case ColumnType.FLOAT:
                return DataType.FLOAT;
            case ColumnType.INTEGER:
                return DataType.INTEGER;
            case ColumnType.STRING:
                return DataType.STRING;
            default:
                return DataType.UNDEFINED;
        }
    }
    get roleType() {
        return this._roleType;
    }
    get varType() {
        return this._varType;
    }
    get defaultAggregate() {
        return AggregateFunction.SUM;
    }
}
